import { IState } from '../../store';

export const selectOfferBookingEnabled = (state: IState): boolean => state.newbuildingBrokerOfferBooking.enabled;
